<template>
  <div
    v-show="show && enabled"
    class="row">
    <div class="col-12 text-center p-2 bg-info animate__animated animate__fadeInDown animate__faster">
      <router-link
        :to="{name: 'Suggest'}"
        style="color: white;">
        Don’t see what you are looking for on the {{ company }} eStore? <strong>CLICK HERE</strong> to suggest product additions.
      </router-link>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import { useRoute } from 'vue-router';
  import moment from 'moment';

  // Initialize
  const store = useStore()
  const route = useRoute()

  // Computed
  const lastRender = computed(()=>{
    return moment(store.getters.suggestLastRender)
  })

  const company = computed(()=>{
    return store.getters.sessionCompany
  })

  const enabled = computed(()=>{
    return store.getters.settings.customerSuggestions
  })

  // Data
  const show = ref(true)

  // LifeCycle
  onMounted(()=>{
    processShow()
  })

  // Methods
  const processShow = ()=>{
    if(route.path == '/virtual_show'){
      show.value = false
    }else{
      const time = moment()
      // To set how long the user should go without seeing banner use timeWindow
      const timeWindow = 5
      if(time > lastRender?.value.add(timeWindow, 'minutes') || lastRender.value.format() == 'Invalid date'){
        show.value = true
        store.dispatch('setSuggestTime')
      }else{
        show.value = false
      }
    }
  }

</script>